import moment from "moment";
import { specificPoints } from '../data/specific_points';

// #575: corte da conversao de tempo especial em comum. Converte ate 12/11/2019 (inclusive); 13/11/2019 em diante e tempo comum.
const CONVERSAO_ESPECIAL_ULTIMO_DIA = '2019-11-12';
const CONVERSAO_ESPECIAL_PRIMEIRO_DIA_COMUM = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA).add(1, 'day').format('YYYY-MM-DD'); // 2019-11-13
// Intervalo de 1 dia e descartado por `end.isAfter(start)`. Nas fronteiras do marco o dia e obrigatorio:
// 12/11 (ultimo convertido) e 13/11 (primeiro comum).
const isDiaUnicoDoMarco = (start, end) => start.isSame(end, 'day') &&
  (start.isSame(CONVERSAO_ESPECIAL_ULTIMO_DIA, 'day') || start.isSame(CONVERSAO_ESPECIAL_PRIMEIRO_DIA_COMUM, 'day'));
// Vinculo especial que comeca no proprio 12/11 com limite tambem em 12/11 ainda converte esse dia (o portao
// `ingress < limite` o barraria e o ultimo dia convertido sumiria).
const ingressAceitoNoLimite = (ingress, limit) => moment(ingress).isBefore(limit) ||
  (moment(ingress).isSame(CONVERSAO_ESPECIAL_ULTIMO_DIA, 'day') && moment(limit).isSame(CONVERSAO_ESPECIAL_ULTIMO_DIA, 'day'));

const calculateDate = (initialDate, finalDate) => {
  try {
    let initialYears = initialDate.year();
    let initialMonths = initialDate.month() + 1;
    let initialDays = initialDate.date();

    let finalYears = finalDate.year();
    let finalMonths = finalDate.month() + 1;
    let finalDays = finalDate.date();

    let years = 0;
    let months = 0;
    let days = 0;

    if (finalDays - initialDays < 0) {
      finalMonths -= 1;
      finalDays += 30;
    }

    days = finalDays - initialDays;

    if (finalMonths - initialMonths < 0) {
      finalYears -= 1;
      finalMonths += 12;
    }

    months = finalMonths - initialMonths;

    years = finalYears - initialYears;

    days += 1;

    return { days, months, years };
  } catch (error) {
    throw new Error(error);
  }
}

// old version
// const getTime = (workRecords, limitDate = null, field = null, gender, regimeDate, ignoreSpecial = false) => {
//   const dates = [];

//   if (!regimeDate) {
//     regimeDate = moment().add(1, 'day').format('YYYY-MM-DD');
//   }

//   let disablementLevel = null;

//   if (field && field.includes("isDisabled")) {
//     disablementLevel = field.split("-")[1];
//     field = "isDisabled";
//   }

//   workRecords.forEach((workRecord) => {
//     const { ingressDate, egressDate, addition, deduction1, deduction2, deduction3, isSpecialTime, disabledLevel } = workRecord;      

//     if (!field || (field && workRecord[field] && (!disablementLevel || disablementLevel === disabledLevel))) {
//       if (isSpecialTime && !field && moment(ingressDate).isBefore(moment(regimeDate))) {
//         const multiple = (ignoreSpecial) ? 1 : (gender === "Homem") ? 1.4 : 1.2;
        
//         if (limitDate) {
//           if (moment(ingressDate).isBefore(limitDate)) {
//             let egress = null;

//             let isLimitDate = false;

//             if (moment(egressDate).isBefore(limitDate)) {
//               egress = moment(egressDate);
//             } else {
//               egress = moment(limitDate);
//               isLimitDate = true;
//             }

//             let isBefore2019 = false;

//             if (egress.isSameOrBefore('2019-12-13')) {
//               egress = moment(isLimitDate ? limitDate : egressDate);
//               isBefore2019 = true;
//             } else {
//               egress = moment('2019-12-13');
//             }

//             let ingress = moment(ingressDate);

//             egress.add((addition * 2), 'days');
//             egress.subtract(deduction1, 'days');
    
//             // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
//               egress.subtract(deduction2, 'days');
//             // }
      
//             // if (moment(limitDate).isAfter(moment(regimeDate))) {
//               egress.subtract(deduction3, 'days');
//             // }

//             let result = calculateDate(ingress, egress);

//             let years = result.years;
//             let months = result.months;
//             let days = result.days;

//             // let years = egress.diff(ingress, 'years');
//             // egress = egress.subtract(years, 'years');
//             // let months = egress.diff(ingress, 'months');
//             // egress = egress.subtract(months, 'months');
//             // let days = egress.diff(ingress, 'days');

//             if (multiple > 1) {
//               let allDays = days + (months * 30) + (years * 365);
//               let multipliedDays = allDays * multiple;

//               let extraDays = multipliedDays - allDays;
//               let extraMonths = 0;
//               let extraYears = 0;

//               let floatExtraYears = extraDays / 365;
//               extraYears = Math.floor(floatExtraYears);

//               let floatMonths = (floatExtraYears - extraYears) * 365 / 30;
//               extraMonths = Math.floor(floatMonths);

//               let floatDays = (floatMonths - extraMonths) * 30;
//               extraDays = Math.floor(floatDays);

//               days += extraDays;
//               months += extraMonths;
//               years += extraYears;
//             }

//             if (!isBefore2019) {
//               egress = moment(isLimitDate ? limitDate : egressDate);
//               ingress = moment('2019-12-13').add(1, 'day');

//               // let years2 = egress.diff(ingress, 'years');
//               // egress = egress.subtract(years2, 'years');
//               // let months2 = egress.diff(ingress, 'months');
//               // egress = egress.subtract(months2, 'months');
//               // let days2 = egress.diff(ingress, 'days');

//               let result = calculateDate(ingress, egress);

//               let years2 = result.years;
//               let months2 = result.months;
//               let days2 = result.days;

//               years += years2;
//               months += months2;
//               days += days2;
//             }

//             dates.push({ years, months, days });
//           }
//         } else {
//           let egress = null;
//           let isBefore2019 = false;

//           if (moment(egressDate).isSameOrBefore('2019-12-13')) {
//             egress = moment(egressDate);
//             isBefore2019 = true;
//           } else {
//             egress = moment('2019-12-13');
//           }
          
//           let ingress = moment(ingressDate);
  
//           egress.add((addition * 2), 'days');
//           egress.subtract(deduction1, 'days');
//           egress.subtract(deduction2, 'days');
//           egress.subtract(deduction3, 'days');

//           let result = calculateDate(ingress, egress);

//           let years = result.years;
//           let months = result.months;
//           let days = result.days;

//           // let years = egress.diff(ingress, 'years');
//           // egress = egress.subtract(years, 'years');
//           // let months = egress.diff(ingress, 'months');
//           // egress = egress.subtract(months, 'months');
//           // let days = egress.diff(ingress, 'days');

//           if (multiple > 1) {
//             let allDays = days + (months * 30) + (years * 365);
//             let multipliedDays = allDays * 1.2;

//             let extraDays = multipliedDays - allDays;
//             let extraMonths = 0;
//             let extraYears = 0;

//             let floatExtraYears = extraDays / 365;
//             extraYears = Math.floor(floatExtraYears);

//             let floatMonths = (floatExtraYears - extraYears) * 365 / 30;
//             extraMonths = Math.floor(floatMonths);

//             let floatDays = (floatMonths - extraMonths) * 30;
//             extraDays = Math.floor(floatDays);

//             days += extraDays;
//             months += extraMonths;
//             years += extraYears;
//           }

//           if (!isBefore2019) {
//             egress = moment(egressDate);
//             ingress = moment('2019-12-13').add(1, 'day');

//             // let years2 = egress.diff(ingress, 'years');
//             // egress = egress.subtract(years2, 'years');
//             // let months2 = egress.diff(ingress, 'months');
//             // egress = egress.subtract(months2, 'months');
//             // let days2 = egress.diff(ingress, 'days');

//             let result = calculateDate(ingress, egress);

//             let years2 = result.years;
//             let months2 = result.months;
//             let days2 = result.days;
            
//             years += years2;
//             months += months2;
//             days += days2;
//           }
    
//           dates.push({ years, months, days });
//         }
//       } else {
//         if (limitDate) {

//           if (moment(ingressDate).isBefore(limitDate)) {
//             let egress = null;

//             if (moment(egressDate).isBefore(limitDate)) {
//               egress = moment(egressDate)
//             } else {
//               egress = moment(limitDate);
//             }

//             let ingress = moment(ingressDate);

//             egress.add((addition * 2), 'days');
//             egress.subtract(deduction1, 'days');
    
//             // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
//               egress.subtract(deduction2, 'days');
//             // }
      
//             // if (moment(limitDate).isAfter(moment(regimeDate))) {
//               egress.subtract(deduction3, 'days');
//             // }

//             let result = calculateDate(ingress, egress);

//             let years = result.years;
//             let months = result.months;
//             let days = result.days;

//             // const years = egress.diff(ingress, 'years');
//             // egress = egress.subtract(years, 'years');
//             // const months = egress.diff(ingress, 'months');
//             // egress = egress.subtract(months, 'months');
//             // const days = egress.diff(ingress, 'days');

//             // if (teste) console.log({ years, months, days });

//             dates.push({ years, months, days });
//           }
//         } else {
//           let egress = moment(egressDate);
//           let ingress = moment(ingressDate);
  
//           egress.add((addition * 2), 'days');
//           egress.subtract(deduction1, 'days');
//           egress.subtract(deduction2, 'days');
//           egress.subtract(deduction3, 'days');

//           let result = calculateDate(ingress, egress);

//           let years = result.years;
//           let months = result.months;
//           let days = result.days;

//           // const years = egress.diff(ingress, 'years');
//           // egress = egress.subtract(years, 'years');
//           // const months = egress.diff(ingress, 'months');
//           // egress = egress.subtract(months, 'months');
//           // const days = egress.diff(ingress, 'days');
    
//           dates.push({ years, months, days });
//         }
//       }
//     }
//   });

//   let years = 0;
//   let months = 0;
//   let days = 0;

//   for (const date of dates) {
//     years += date.years;
//     months += date.months;
//     days += date.days;
//   }

//   if (days >= 30) {
//     const daysToMonths = Math.floor(days / 30);

//     days -= (daysToMonths * 30);
//     months += daysToMonths;
//   }

//   if (months >= 12) {
//     const monthsToYears = Math.floor(months / 12);

//     months -= (monthsToYears * 12);
//     years += monthsToYears;
//   }

//   years = Math.floor(years);
//   months = Math.floor(months);
//   days = Math.floor(days);

//   const hasTime = (years+months+days) > 0;

//   return { years, months, days, hasTime };
// }

// ===== Gate de precedencia (hotfix PCD "Completou em") =====
// Ha conflito REAL de precedencia entre vinculos concomitantes?
//
// Conflito = dois vinculos do MESMO regimeType, ja normalizados (corte por
// limitDate, ajuste RGPS pos-14/11/2019 com excecao MIN_SALARY, addition*2 e as
// tres deducoes), cujos intervalos se sobrepoem e cujas PRIORIDADES DIFEREM na
// escala grave > moderada > leve > comum.
//
// NAO sao conflito: regimes diferentes; mesma natureza e mesmo grau; ausencia de
// sobreposicao; especial/magisterio sem PCD; diferenca apenas de multiplicador.
// O resultado independe da ordem dos vinculos (a verificacao e sobre pares).
//
// Enquanto a precedencia juridica definida pela Ju nao for implementada
// (card Trello #522), esses casos permanecem no walker legado.
const PCD_PRIORITY = { high: 4, medium: 3, low: 2, comum: 1 };

const hasPrecedenceConflict = (workRecords, limitDate) => {
  const intervals = [];

  for (const w of workRecords || []) {
    // MESMA ordem de teste de getMultiplierForRecord: isDisabled ANTES de especial/magisterio
    let priority = null;
    if (w.isDisabled) priority = PCD_PRIORITY[w.disabledLevel || ''] || null;
    else if (w.isSpecialTime || w.isTeachingTime) priority = null;
    else priority = PCD_PRIORITY.comum;
    if (!priority) continue;

    let ingressDate = moment(w.ingressDate);
    let egressDate = moment(w.egressDate);

    if (w.regimeType !== 'RPPS') {
      if (ingressDate.isAfter('2019-11-14')) {
        const s = w.salaries ? w.salaries.find(x => x.month === ingressDate.format('MM') && x.year === ingressDate.format('YYYY')) : null;
        if (!(s && s.value > 0 && s.warnings && s.warnings.includes('MIN_SALARY'))) ingressDate = moment(ingressDate).startOf('month');
      }
      if (egressDate.isAfter('2019-11-14')) {
        const s = w.salaries ? w.salaries.find(x => x.month === egressDate.format('MM') && x.year === egressDate.format('YYYY')) : null;
        if (!(s && s.value > 0 && s.warnings && s.warnings.includes('MIN_SALARY'))) egressDate = moment(egressDate).endOf('month');
      }
    }

    if (limitDate && !ingressDate.isBefore(limitDate)) continue;

    const egress = moment(limitDate && moment(egressDate).isAfter(limitDate) ? limitDate : egressDate)
      .add((w.addition || 0) * 2, 'days')
      .subtract(w.deduction1 || 0, 'days')
      .subtract(w.deduction2 || 0, 'days')
      .subtract(w.deduction3 || 0, 'days');

    if (!egress.isAfter(ingressDate)) continue;
    intervals.push({ priority, start: ingressDate, end: egress, regimeKey: w.regimeType === 'RPPS' ? 'RPPS' : 'RGPS' });
  }

  for (let i = 0; i < intervals.length; i += 1) {
    for (let j = i + 1; j < intervals.length; j += 1) {
      const a = intervals[i];
      const b = intervals[j];
      if (a.regimeKey !== b.regimeKey) continue;
      if (a.priority === b.priority) continue;
      if (a.start.isBefore(b.end) && b.start.isBefore(a.end)) return true;
    }
  }

  return false;
};

const getTime = (workRecords, limitDate = null, field = null, gender, regimeDate, ignoreSpecial = false, necessaryContribution = null, useMainDisabledTimeWithConversion = false) => {
  const dates = [];

  const usedIntervals = {
    RPPS: [],
    RGPS: []
  }

  const subtractUsedFromInterval = (start, end, regimeType, localUsed = null) => {
    const used = localUsed ? localUsed[regimeType] : usedIntervals[regimeType];
    let segs = [{ start: start.clone(), end: end.clone() }];
    for (const u of used || []) {
      if (u.start.isSame(u.end)) { // dia unico do marco ja contado (so o dia preservado gera isto)
        const nextD = [];
        for (const s of segs) {
          if (u.start.isBefore(s.start, 'day') || u.start.isAfter(s.end, 'day')) { nextD.push(s); continue; }
          if (u.start.isAfter(s.start, 'day')) nextD.push({ start: s.start.clone(), end: u.start.clone().subtract(1, 'day'), keep1: true });
          if (u.start.isBefore(s.end, 'day')) nextD.push({ start: u.start.clone().add(1, 'day'), end: s.end.clone(), keep1: true });
        }
        segs = nextD;
        if (!segs.length) break;
        continue;
      }
      const next = [];
      for (const s of segs) {
        if (u.end.isSameOrBefore(s.start) || u.start.isSameOrAfter(s.end)) {
          next.push(s);
        } else {
          if (u.start.isAfter(s.start)) {
            next.push({ start: s.start.clone(), end: moment.min(u.start, s.end).clone() });
          }
          if (u.end.isBefore(s.end)) {
            next.push({ start: moment.max(u.end, s.start).clone(), end: s.end.clone() });
          }
        }
      }
      segs = next;
      if (!segs.length) break;
    }
    let out = segs.filter(s => s.keep1 || s.end.isAfter(s.start));
    // pedaco keep1 (sobra do corte do dia preservado, 1 dia inclusive): exclusao POR DIA contra qualquer intervalo usado,
    // inclusive os nao degenerados que comecam/terminam no mesmo dia (o teste `u.start >= s.end` o deixaria passar e o dia entraria 2x)
    if (out.some(s => s.keep1)) {
      for (const u of used || []) {
        const nx = [];
        for (const s of out) {
          if (!s.keep1 || u.end.isBefore(s.start, 'day') || u.start.isAfter(s.end, 'day')) { nx.push(s); continue; }
          if (u.start.isAfter(s.start, 'day')) nx.push({ start: s.start.clone(), end: u.start.clone().subtract(1, 'day'), keep1: true });
          if (u.end.isBefore(s.end, 'day')) nx.push({ start: u.end.clone().add(1, 'day').startOf('day'), end: s.end.clone(), keep1: true });
        }
        out = nx;
        if (!out.length) break;
      }
    }
    return out;
  };

  const registerUsed = (segments, regimeType, localUsed = null) => {
    const target = localUsed ? localUsed[regimeType] : usedIntervals[regimeType];
    if (!target) return;
    for (const s of segments) {
      target.push({ start: s.start.clone(), end: s.end.clone() });
    }
  };

  const calcNonOverlap = (start, end, regimeType) => {
    const segments = subtractUsedFromInterval(start, end, regimeType);
    let years = 0, months = 0, days = 0;
    for (const s of segments) {
      const r = calculateDate(s.start.clone(), s.end.clone());
      years += r.years; months += r.months; days += r.days;
    }
    registerUsed(segments, regimeType);
    return { years, months, days };
  };

  const diaJaUsado = (dia, regimeType, localUsed = null) =>
    ((localUsed ? localUsed[regimeType] : usedIntervals[regimeType]) || [])
      .some(u => u.start.isSameOrBefore(dia, 'day') && u.end.isSameOrAfter(dia, 'day'));

  // dia unico do marco: conta 1 dia uma so vez (em qualquer ordem dos vinculos) e o registra como usado
  const calcNonOverlapMarco = (start, end, regimeType) => {
    if (!isDiaUnicoDoMarco(start, end)) return calcNonOverlap(start, end, regimeType);
    if (diaJaUsado(start, regimeType)) return { years: 0, months: 0, days: 0 };
    const dia = start.clone().startOf('day');
    registerUsed([{ start: dia, end: dia.clone() }], regimeType);
    return calculateDate(dia.clone(), dia.clone());
  };

  const getSpecialMultiple = (specialTimeLevel, gender) => {
    switch (specialTimeLevel) {
      case "15 anos":
        return (gender === "Homem") ? 2.33 : 2;
      case "20 anos":
        return (gender === "Homem") ? 1.75 : 1.5;
      case "25 anos":
      default:
        return (gender === "Homem") ? 1.4 : 1.2;
    }
  };

  if (!regimeDate) {
    regimeDate = moment().add(1, 'day').format('YYYY-MM-DD');
  }

  let disablementLevel = null;

  if (field && field.includes("isDisabled")) {
    disablementLevel = field.split("-")[1];
    field = "isDisabled";
  }

  let specialTimeLevel = null;

  if (field && field.includes("isSpecialTime")) {
    specialTimeLevel = field.split("-")[1];
    field = "isSpecialTime";
  }

  if (field && field.includes("comum")) {
    workRecords = workRecords.filter(workRecord => !workRecord.isSpecialTime && !workRecord.isDisabled && !workRecord.isTeachingTime);
    field = null;
  }

  // se necessaryContribution fornecido, simula acumulação cronológica (respeitando regras) e retorna data de conclusão
  if (necessaryContribution) {
    const toTotalDays = (c) => {
      if (typeof c === 'number') return Math.floor(c * 365);
      if (c && typeof c === 'object') {
        const y = c.years || 0;
        const m = c.months || 0;
        const d = c.days || 0;
        return Math.floor((y * 365) + (m * 30) + d);
      }
      return 0;
    }

    const requiredDays = toTotalDays(necessaryContribution);
    if (requiredDays <= 0) return { completionDate: null };

    // localUsed para simulação (não altera usedIntervals real)
    const localUsed = { RPPS: [], RGPS: [] };

    const calcDaysForSegment = (start, end) => {
      const r = calculateDate(start.clone(), end.clone());
      return (r.years * 365) + (r.months * 30) + r.days;
    };

    // ===== NOVA LÓGICA: COM CONVERSÃO DE TEMPO PREDOMINANTE =====
    if (useMainDisabledTimeWithConversion && field === "isDisabled") {
      const disabledLowTimeGeral = getTime(workRecords, limitDate, 'isDisabled-low', gender, regimeDate, ignoreSpecial, null, false);
      const disabledMediumTimeGeral = getTime(workRecords, limitDate, 'isDisabled-medium', gender, regimeDate, ignoreSpecial, null, false);
      const disabledHighTimeGeral = getTime(workRecords, limitDate, 'isDisabled-high', gender, regimeDate, ignoreSpecial, null, false);
      const comumContributionGeral = getTime(workRecords, limitDate, 'comum', gender, regimeDate, true, null, false);

      const mainDisabledTime = getMainDisabledTimeWithConversion(
        gender,
        disabledLowTimeGeral,
        disabledMediumTimeGeral,
        disabledHighTimeGeral,
        comumContributionGeral
      );

      // Caminho PREEXISTENTE: regra sem grau exigido. Entra como sempre entrou.
      // O gate NAO e consultado aqui — senao o hotfix mudaria comportamento preexistente.
      const alreadyUsedConversion = !disablementLevel;

      // Caminho NOVO admitido por este hotfix: regra COM grau. So entra quando:
      //  1) o grau predominante e o exigido;
      //  2) a conversao ACRESCENTA tempo — se o bruto no grau ja e igual ao
      //     convertido, nao ha nada a converter, e entrar aqui trocaria o walker
      //     civil pela aritmetica comercial 365/30, movendo a data em dias sem
      //     beneficio (regressao do fix de drift de 04/07/2026);
      //  3) nao ha conflito de precedencia entre vinculos concomitantes (card #522).
      const rawForLevel = disablementLevel
        ? ({ low: disabledLowTimeGeral,
             medium: disabledMediumTimeGeral,
             high: disabledHighTimeGeral })[disablementLevel]
        : null;
      const conversionAddsTime = !!rawForLevel
        && toTotalDays(mainDisabledTime) > toTotalDays(rawForLevel);

      const newlyEligible = !!disablementLevel
        && mainDisabledTime.mainDisabledLevel === disablementLevel
        && conversionAddsTime
        && !hasPrecedenceConflict(workRecords, limitDate);

      if (!alreadyUsedConversion && !newlyEligible) {
        // segue para o walker legado, byte a byte como hoje
      } else {

      if (!mainDisabledTime.hasTime || !mainDisabledTime.mainDisabledLevel) {
        return { completionDate: null };
      }

      const availableConvertedDays = toTotalDays(mainDisabledTime);
      if (availableConvertedDays < requiredDays) {
        return { completionDate: null };
      }

      const mainLevel = mainDisabledTime.mainDisabledLevel;
      const isMale = gender === 'Homem';

      const conversionMultipliers = {
        low: {
          low: 1,
          medium: isMale ? 1.14 : 1.17,
          high: isMale ? 1.32 : 1.4,
          comum: isMale ? 0.94 : 0.93,
        },
        medium: {
          low: isMale ? 0.88 : 0.86,
          medium: 1,
          high: isMale ? 1.16 : 1.2,
          comum: isMale ? 0.83 : 0.8,
        },
        high: {
          low: isMale ? 0.76 : 0.71,
          medium: isMale ? 0.86 : 0.83,
          high: 1,
          comum: isMale ? 0.71 : 0.67,
        },
      };

      const resolveRegimeType = (regimeType) => (regimeType === 'RPPS' ? 'RPPS' : 'RGPS');
      const multipliers = conversionMultipliers[mainLevel] || null;

      if (!multipliers) {
        return { completionDate: null };
      }

      const getMultiplierForRecord = (record) => {
        if (record.isDisabled) {
          const level = record.disabledLevel || '';
          return multipliers[level] || null;
        }

        if (record.isSpecialTime || record.isTeachingTime) {
          return null;
        }

        return multipliers.comum || null;
      };

      const processSegment = (segStart, segEnd, regimeKey, multiple) => {
        if (!segEnd.isAfter(segStart)) return false;
        const pieces = subtractUsedFromInterval(segStart.clone(), segEnd.clone(), regimeKey, localUsed);
        for (const p of pieces) {
          const realDays = calcDaysForSegment(p.start, p.end);
          const contrib = realDays * multiple;
          if (accumulated + contrib < requiredDays) {
            accumulated += contrib;
            registerUsed([p], regimeKey, localUsed);
          } else {
            const remaining = requiredDays - accumulated;
            const neededReal = remaining / multiple;
            const neededRealCeil = Math.ceil(neededReal);
            const target = p.start.clone().add(neededRealCeil - 1, 'days');
            return target.format('YYYY-MM-DD');
          }
        }
        return false;
      };

      const sorted = [...workRecords].sort((a, b) => moment(a.ingressDate).diff(moment(b.ingressDate)));
      let accumulated = 0;

      for (const workRecord of sorted) {
        const multiple = getMultiplierForRecord(workRecord);
        if (!multiple) continue;

        const regimeKey = resolveRegimeType(workRecord.regimeType);
        let ingressDate = moment(workRecord.ingressDate);
        let egressDate = moment(workRecord.egressDate);

        if (regimeKey === 'RGPS') {
          if (ingressDate.isAfter('2019-11-14')) {
            const salaryOnIngress = workRecord.salaries ? workRecord.salaries.find(s => s.month === ingressDate.format('MM') && s.year === ingressDate.format('YYYY')) : null;
            if (!(salaryOnIngress && salaryOnIngress.value > 0 && salaryOnIngress.warnings && salaryOnIngress.warnings.includes('MIN_SALARY'))) {
              ingressDate = moment(ingressDate).startOf('month');
            }
          }

          if (egressDate.isAfter('2019-11-14')) {
            const salaryOnEgress = workRecord.salaries ? workRecord.salaries.find(s => s.month === egressDate.format('MM') && s.year === egressDate.format('YYYY')) : null;
            if (!(salaryOnEgress && salaryOnEgress.value > 0 && salaryOnEgress.warnings && salaryOnEgress.warnings.includes('MIN_SALARY'))) {
              egressDate = moment(egressDate).endOf('month');
            }
          }
        }

        const addition = workRecord.addition || 0;
        const deduction1 = workRecord.deduction1 || 0;
        const deduction2 = workRecord.deduction2 || 0;
        const deduction3 = workRecord.deduction3 || 0;

        if (limitDate) {
          if (moment(ingressDate).isBefore(limitDate)) {
            const egress = moment(moment(egressDate).isBefore(limitDate) ? egressDate : limitDate);
            const ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
            egress.subtract(deduction2, 'days');
            egress.subtract(deduction3, 'days');

            const res = processSegment(ingress, egress, regimeKey, multiple);
            if (res) return { completionDate: res };
          }
        } else {
          const egress = moment(egressDate).add((addition * 2), 'days').subtract(deduction1, 'days').subtract(deduction2, 'days').subtract(deduction3, 'days');
          const ingress = moment(ingressDate);

          const res = processSegment(ingress, egress, regimeKey, multiple);
          if (res) return { completionDate: res };
        }
      }

      return { completionDate: null };
      }
    }

    // ordena cronologicamente por ingressDate
    const sorted = [...workRecords].sort((a, b) => moment(a.ingressDate).diff(moment(b.ingressDate)));

    let accumulated = 0;
    let lastProcessedRecord = null; // Para rastrear o último registro processado
    
    // processa um segmento (considera não-sobreposição local)
    // Definido fora do loop para poder ser usado após processar todos os registros
    const processSegment = (segStart, segEnd, currentWorkRecord, currentMultiple, permitirDiaMarco = false) => {
      const unico = permitirDiaMarco && isDiaUnicoDoMarco(segStart, segEnd);
      if (!unico && !segEnd.isAfter(segStart)) {
        return false;
      }
      const dia = unico ? segStart.clone().startOf('day') : null;
      const pieces = unico
        ? (diaJaUsado(dia, currentWorkRecord.regimeType, localUsed) ? [] : [{ start: dia, end: dia.clone() }])
        : subtractUsedFromInterval(segStart.clone(), segEnd.clone(), currentWorkRecord.regimeType, localUsed);
      
      for (const p of pieces) {
        const realDays = calcDaysForSegment(p.start, p.end);
        const contrib = realDays * currentMultiple;
        
        if (accumulated + contrib < requiredDays) {
          accumulated += contrib;
          registerUsed([p], currentWorkRecord.regimeType, localUsed);
        } else {
          // necessidade apenas de parte deste pedaço
          const remaining = requiredDays - accumulated;
          const neededReal = remaining / currentMultiple;
          const neededRealCeil = Math.ceil(neededReal);
          // alvo dentro de p: p.start + (neededRealCeil - 1) dias (porque calculateDate conta inclusivamente)
          const target = p.start.clone().add(neededRealCeil - 1, 'days');
          return target.format('YYYY-MM-DD');
        }
      }
      return false;
    };

    for (const workRecord of sorted) {
      const { addition, deduction1, deduction2, deduction3, isSpecialTime, disabledLevel, specialLevel, regimeType } = workRecord;

      let ingressDate = moment(workRecord.ingressDate);
      let egressDate = moment(workRecord.egressDate);

      const ingressOriginal = moment(workRecord.ingressDate); // ingresso real, antes do arredondamento RGPS (#575)
      if (regimeType === 'RGPS') {
        if (ingressDate.isAfter('2019-11-14')) {
          const salaryOnIngress = workRecord.salaries ? workRecord.salaries.find(s => s.month === ingressDate.format('MM') && s.year === ingressDate.format('YYYY')) : null;
          if (!(salaryOnIngress && salaryOnIngress.value > 0 && salaryOnIngress.warnings && salaryOnIngress.warnings.includes('MIN_SALARY'))) {
            ingressDate = moment(ingressDate).startOf('month');
          }
        }
        
        if (egressDate.isAfter('2019-11-14')) {
          const salaryOnEgress = workRecord.salaries ? workRecord.salaries.find(s => s.month === egressDate.format('MM') && s.year === egressDate.format('YYYY')) : null;
          if (!(salaryOnEgress && salaryOnEgress.value > 0 && salaryOnEgress.warnings && salaryOnEgress.warnings.includes('MIN_SALARY'))) {
            egressDate = moment(egressDate).endOf('month');
          }
        }
      }

      if (
        !field || 
        (
          field && 
          workRecord[field] && 
          (!disablementLevel || disablementLevel === disabledLevel) && 
          (!specialTimeLevel || specialTimeLevel === specialLevel)
        )
      ) {
        // multiplicador para esse registro
        let multiple = 1;
        if (isSpecialTime && !field && moment(ingressOriginal).isBefore(moment(CONVERSAO_ESPECIAL_PRIMEIRO_DIA_COMUM))) {
          multiple = ignoreSpecial ? 1 : getSpecialMultiple(specialLevel, gender);
        }

        // aplica mesma lógica de divisão pre/post 2019 e limites que já existia
        if (isSpecialTime && !field && moment(ingressOriginal).isBefore(moment(CONVERSAO_ESPECIAL_PRIMEIRO_DIA_COMUM))) {
          if (limitDate) {
            if (ingressAceitoNoLimite(ingressDate, limitDate)) {
              let egress = null;
              let isLimitDate = false;

              if (moment(egressDate).isBefore(limitDate)) {
                egress = moment(egressDate);
              } else {
                egress = moment(limitDate);
                isLimitDate = true;
              }

              let isBefore2019 = false;

              if (egress.isSameOrBefore(CONVERSAO_ESPECIAL_ULTIMO_DIA)) {
                egress = moment(isLimitDate ? limitDate : egressDate);
                isBefore2019 = true;
              } else {
                egress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA);
              }

              let ingress = moment(ingressDate);

              egress.add((addition * 2), 'days');
              egress.subtract(deduction1, 'days');
              egress.subtract(deduction2, 'days');
              egress.subtract(deduction3, 'days');

              const res = processSegment(ingress, egress, workRecord, multiple, true);
              if (res) return { completionDate: res };

              if (!isBefore2019) {
                egress = moment(isLimitDate ? limitDate : egressDate);
                ingress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA).add(1, 'day');
                const res2 = processSegment(ingress, egress, workRecord, 1, true);
                if (res2) return { completionDate: res2 };
              }
            }
          } else {
            let egress = null;
            let isBefore2019 = false;

            if (moment(egressDate).isSameOrBefore(CONVERSAO_ESPECIAL_ULTIMO_DIA)) {
              egress = moment(egressDate);
              isBefore2019 = true;
            } else {
              egress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA);
            }
            
            let ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
            egress.subtract(deduction2, 'days');
            egress.subtract(deduction3, 'days');

            const res = processSegment(ingress, egress, workRecord, multiple, true);
            if (res) return { completionDate: res };

            if (!isBefore2019) {
              egress = moment(egressDate);
              ingress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA).add(1, 'day');
              const res2 = processSegment(ingress, egress, workRecord, 1, true);
              if (res2) return { completionDate: res2 };
            }
          }
        } else {
          if (limitDate) {
            if (moment(ingressDate).isBefore(limitDate)) {
              let egress = null;
              let useLimitDate = false;

              if (moment(egressDate).isBefore(limitDate)) {
                // Se egressDate é antes de limitDate, primeiro tenta com egressDate
                egress = moment(egressDate);
              } else {
                egress = moment(limitDate);
                useLimitDate = true;
              }

              let ingress = moment(ingressDate);

              egress.add((addition * 2), 'days');
              egress.subtract(deduction1, 'days');
              egress.subtract(deduction2, 'days');
              egress.subtract(deduction3, 'days');

              const res = processSegment(ingress, egress, workRecord, multiple);
              if (res) return { completionDate: res };
              // Rastreia o último registro processado que termina antes do limitDate para possível período adicional
              if (moment(egressDate).isBefore(limitDate)) {
                lastProcessedRecord = { workRecord, egressDate: moment(egressDate), addition, deduction1, deduction2, deduction3 };
              }
            }
          } else {
            let egress = moment(egressDate);
            let ingress = moment(ingressDate);
    
            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
            egress.subtract(deduction2, 'days');
            egress.subtract(deduction3, 'days');

            const res = processSegment(ingress, egress, workRecord, multiple);
            if (res) return { completionDate: res };
            // Rastreia o último registro processado
            lastProcessedRecord = { workRecord, egressDate: moment(egressDate), addition, deduction1, deduction2, deduction3 };
          }
        }
      }
    }

    // Se não completou e há um último registro que termina antes do limitDate, tenta processar período adicional
    if (lastProcessedRecord && limitDate && moment(lastProcessedRecord.egressDate).isBefore(limitDate)) {
      let egressLimit = moment(limitDate);
      egressLimit.add((lastProcessedRecord.addition * 2), 'days');
      egressLimit.subtract(lastProcessedRecord.deduction1, 'days');
      egressLimit.subtract(lastProcessedRecord.deduction2, 'days');
      egressLimit.subtract(lastProcessedRecord.deduction3, 'days');
      
      // Processa apenas o período entre o último egressDate e o limitDate
      let ingressLimit = moment(lastProcessedRecord.egressDate).add(1, 'day');
      // Usa o último registro processado para o período adicional (multiple = 1 para tempo comum)
      const res = processSegment(ingressLimit, egressLimit, lastProcessedRecord.workRecord, 1);
      if (res) return { completionDate: res };
    }

    // não atingiu
    return { completionDate: null };
  }

  // sem necessaryContribution: comportamento original (inalterado)
  workRecords.forEach((workRecord) => {
    const { addition, deduction1, deduction2, deduction3, isSpecialTime, disabledLevel, specialLevel, regimeType } = workRecord;      

    let ingressDate = moment(workRecord.ingressDate);
    let egressDate = moment(workRecord.egressDate);

    const ingressOriginal = moment(workRecord.ingressDate); // ingresso real, antes do arredondamento RGPS (#575)
    if (regimeType === 'RGPS') {
      if (ingressDate.isAfter('2019-11-14')) {
        const salaryOnIngress = workRecord.salaries ? workRecord.salaries.find(s => s.month === ingressDate.format('MM') && s.year === ingressDate.format('YYYY')) : null;
        if (salaryOnIngress && salaryOnIngress.value > 0 && salaryOnIngress.warnings && salaryOnIngress.warnings.includes('MIN_SALARY')) {
          
        } else {
          ingressDate = moment(ingressDate).startOf('month');
        }
      }
      
      if (egressDate.isAfter('2019-11-14')) {
        const salaryOnEgress = workRecord.salaries ? workRecord.salaries.find(s => s.month === egressDate.format('MM') && s.year === egressDate.format('YYYY')) : null;
        if (salaryOnEgress && salaryOnEgress.value > 0 && salaryOnEgress.warnings && salaryOnEgress.warnings.includes('MIN_SALARY')) {
          
        } else {
          egressDate = moment(egressDate).endOf('month');
        }
      }
    }

    if (
      !field || 
      (
        field && 
        workRecord[field] && 
        (!disablementLevel || disablementLevel === disabledLevel) && 
        (!specialTimeLevel || specialTimeLevel === specialLevel)
      )
    ) {
      if (isSpecialTime && !field && moment(ingressOriginal).isBefore(moment(CONVERSAO_ESPECIAL_PRIMEIRO_DIA_COMUM))) {
        const multiple = ignoreSpecial ? 1 : getSpecialMultiple(specialLevel, gender);
        
        if (limitDate) {
          if (ingressAceitoNoLimite(ingressDate, limitDate)) {
            let egress = null;

            let isLimitDate = false;

            if (moment(egressDate).isBefore(limitDate)) {
              egress = moment(egressDate);
            } else {
              egress = moment(limitDate);
              isLimitDate = true;
            }

            let isBefore2019 = false;

            if (egress.isSameOrBefore(CONVERSAO_ESPECIAL_ULTIMO_DIA)) {
              egress = moment(isLimitDate ? limitDate : egressDate);
              isBefore2019 = true;
            } else {
              egress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA);
            }

            let ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
    
            // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
              egress.subtract(deduction2, 'days');
            // }
      
            // if (moment(limitDate).isAfter(moment(regimeDate))) {
              egress.subtract(deduction3, 'days');
            // }

            let result = calcNonOverlapMarco(ingress, egress, workRecord.regimeType);
            // let result = calculateDate(ingress, egress);

            let years = result.years;
            let months = result.months;
            let days = result.days;

            if (multiple > 1) {
              let allDays = days + (months * 30) + (years * 365);
              let multipliedDays = allDays * multiple;

              let extraDays = multipliedDays - allDays;
              let extraMonths = 0;
              let extraYears = 0;

              let floatExtraYears = extraDays / 365;
              extraYears = Math.floor(floatExtraYears);

              let floatMonths = (floatExtraYears - extraYears) * 365 / 30;
              extraMonths = Math.floor(floatMonths);

              let floatDays = (floatMonths - extraMonths) * 30;
              extraDays = Math.floor(floatDays);

              days += extraDays;
              months += extraMonths;
              years += extraYears;
            }

            if (!isBefore2019) {
              egress = moment(isLimitDate ? limitDate : egressDate);
              ingress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA).add(1, 'day');

              let result2 = calcNonOverlapMarco(ingress, egress, workRecord.regimeType);
              // let result2 = calculateDate(ingress, egress);

              let years2 = result2.years;
              let months2 = result2.months;
              let days2 = result2.days;

              years += years2;
              months += months2;
              days += days2;
            }

            dates.push({ years, months, days });
          }
        } else {
          let egress = null;
          let isBefore2019 = false;

          if (moment(egressDate).isSameOrBefore(CONVERSAO_ESPECIAL_ULTIMO_DIA)) {
            egress = moment(egressDate);
            isBefore2019 = true;
          } else {
            egress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA);
          }
          
          let ingress = moment(ingressDate);
  
          egress.add((addition * 2), 'days');
          egress.subtract(deduction1, 'days');
          egress.subtract(deduction2, 'days');
          egress.subtract(deduction3, 'days');

          let result = calcNonOverlapMarco(ingress, egress, workRecord.regimeType);
          // let result = calculateDate(ingress, egress);

          let years = result.years;
          let months = result.months;
          let days = result.days;

          if (multiple > 1) {
            let allDays = days + (months * 30) + (years * 365);
            let multipliedDays = allDays * 1.2;

            let extraDays = multipliedDays - allDays;
            let extraMonths = 0;
            let extraYears = 0;

            let floatExtraYears = extraDays / 365;
            extraYears = Math.floor(floatExtraYears);

            let floatMonths = (floatExtraYears - extraYears) * 365 / 30;
            extraMonths = Math.floor(floatMonths);

            let floatDays = (floatMonths - extraMonths) * 30;
            extraDays = Math.floor(floatDays);

            days += extraDays;
            months += extraMonths;
            years += extraYears;
          }

          if (!isBefore2019) {
            egress = moment(egressDate);
            ingress = moment(CONVERSAO_ESPECIAL_ULTIMO_DIA).add(1, 'day');

            let result2 = calcNonOverlapMarco(ingress, egress, workRecord.regimeType);
            // let result2 = calculateDate(ingress, egress);

            let years2 = result2.years;
            let months2 = result2.months;
            let days2 = result2.days;
            
            years += years2;
            months += months2;
            days += days2;
          }
    
          dates.push({ years, months, days });
        }
      } else {
        if (limitDate) {

          if (moment(ingressDate).isBefore(limitDate)) {
            let egress = null;

            if (moment(egressDate).isBefore(limitDate)) {
              egress = moment(egressDate)
            } else {
              egress = moment(limitDate);
            }

            let ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
    
            // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
              egress.subtract(deduction2, 'days');
            // }
      
            // if (moment(limitDate).isAfter(moment(regimeDate))) {
              egress.subtract(deduction3, 'days');
            // }

            // >>> ALTERAÇÃO PONTUAL: usa cálculo sem sobreposição <<<
            let result = calcNonOverlap(ingress, egress, workRecord.regimeType);
            // let result = calculateDate(ingress, egress);
            // <<<

            let years = result.years;
            let months = result.months;
            let days = result.days;

            dates.push({ years, months, days });
          }
        } else {
          let egress = moment(egressDate);
          let ingress = moment(ingressDate);
  
          egress.add((addition * 2), 'days');
          egress.subtract(deduction1, 'days');
          egress.subtract(deduction2, 'days');
          egress.subtract(deduction3, 'days');

          let result = calcNonOverlap(ingress, egress, workRecord.regimeType);
          // let result = calculateDate(ingress, egress);

          let years = result.years;
          let months = result.months;
          let days = result.days;
    
          dates.push({ years, months, days });
        }
      }
    }
  });

  let years = 0;
  let months = 0;
  let days = 0;

  for (const date of dates) {
    years += date.years;
    months += date.months;
    days += date.days;
  }

  if (days >= 30) {
    const daysToMonths = Math.floor(days / 30);

    days -= (daysToMonths * 30);
    months += daysToMonths;
  }

  if (months >= 12) {
    const monthsToYears = Math.floor(months / 12);

    months -= (monthsToYears * 12);
    years += monthsToYears;
  }

  years = Math.floor(years);
  months = Math.floor(months);
  days = Math.floor(days);

  const hasTime = (years+months+days) > 0;

  return { years, months, days, hasTime };
}

const getMainSpecialTimeWithConversion = (specialTime15, specialTime20, specialTime25) => {
  const specialTime15Years = specialTime15.years;
  const specialTime20Years = specialTime20.years;
  const specialTime25Years = specialTime25.years;

  const specialTime15Months = specialTime15.months;
  const specialTime20Months = specialTime20.months;
  const specialTime25Months = specialTime25.months;

  const specialTime15Days = specialTime15.days;
  const specialTime20Days = specialTime20.days;
  const specialTime25Days = specialTime25.days;

  let days15 = specialTime15Days;
  days15 = days15 + (specialTime15Months * 30);
  days15 = days15 + (specialTime15Years * 365);

  let days20 = specialTime20Days;
  days20 = days20 + (specialTime20Months * 30);
  days20 = days20 + (specialTime20Years * 365);

  let days25 = specialTime25Days;
  days25 = days25 + (specialTime25Months * 30);
  days25 = days25 + (specialTime25Years * 365);

  let response = {
    mainSpecialLevel: '',
    years: 0,
    months: 0,
    days: 0,
    hasTime: false,
  }

  if (!days15 && !days20 && !days25) {
    return response;
  }

  response.hasTime = true;

  if (
    days15 > days20 && 
    days15 > days25
  ) {
    response.mainSpecialLevel = "15 anos";
    
    // * 20 to 15 | 0.75
    days15 = days15 + (days20 * 0.75);

    // * 25 to 15 | 0.6
    days15 = days15 + (days25 * 0.6);
    
    response.years = Math.floor(days15 / 365);
    response.months = Math.floor((days15 % 365) / 30);
    response.days = Math.floor((days15 % 365) % 30);
  } else if (
    days20 > days15 && 
    days20 > days25
  ) {
    response.mainSpecialLevel = "20 anos";

    // * 15 to 20 | 1.33
    days20 = days20 + (days15 * 1.33);

    // * 25 to 20 | 0.8
    days20 = days20 + (days25 * 0.8);

    response.years = Math.floor(days20 / 365);
    response.months = Math.floor((days20 % 365) / 30);
    response.days = Math.floor((days20 % 365) % 30);
  } else if (
    days25 > days15 && 
    days25 > days20
  ) { 
    response.mainSpecialLevel = "25 anos";

    // * 15 to 25 | 1.67
    days25 = days25 + (days15 * 1.67);

    // * 20 to 25 | 1.25
    days25 = days25 + (days20 * 1.25);

    response.years = Math.floor(days25 / 365);
    response.months = Math.floor((days25 % 365) / 30);
    response.days = Math.floor((days25 % 365) % 30);
  }

  return response;
}

const getMainDisabledTimeWithConversion = (gender, disabledTimeLow, disabledTimeMedium, disabledTimeHigh, comumContribution) => {
  const disabledTimeLowYears = disabledTimeLow.years;
  const disabledTimeMediumYears = disabledTimeMedium.years;
  const disabledTimeHighYears = disabledTimeHigh.years;

  const disabledTimeLowMonths = disabledTimeLow.months;
  const disabledTimeMediumMonths = disabledTimeMedium.months;
  const disabledTimeHighMonths = disabledTimeHigh.months;

  const disabledTimeLowDays = disabledTimeLow.days;
  const disabledTimeMediumDays = disabledTimeMedium.days;
  const disabledTimeHighDays = disabledTimeHigh.days;

  const comumContributionYears = comumContribution.years;
  const comumContributionMonths = comumContribution.months;
  const comumContributionDays = comumContribution.days;

  let daysLow = disabledTimeLowDays;
  daysLow = daysLow + (disabledTimeLowMonths * 30);
  daysLow = daysLow + (disabledTimeLowYears * 365);

  let daysMedium = disabledTimeMediumDays;
  daysMedium = daysMedium + (disabledTimeMediumMonths * 30);
  daysMedium = daysMedium + (disabledTimeMediumYears * 365);

  let daysHigh = disabledTimeHighDays;
  daysHigh = daysHigh + (disabledTimeHighMonths * 30);
  daysHigh = daysHigh + (disabledTimeHighYears * 365);

  let daysComum = comumContributionDays;
  daysComum = daysComum + (comumContributionMonths * 30);
  daysComum = daysComum + (comumContributionYears * 365);

  let response = {
    mainDisabledLevel: '',
    mainDisabledLevelLabel: '',
    years: 0,
    months: 0,
    days: 0,
    hasTime: false,
  }

  if (!daysLow && !daysMedium && !daysHigh) {
    return response;
  }

  response.hasTime = true;

  if (
    daysLow > daysMedium && 
    daysLow > daysHigh
  ) {
    response.mainDisabledLevel = "low";
    response.mainDisabledLevelLabel = "Leve";
    
    if (gender === "Homem") {
      // * medium to low | 1.14
      daysLow = daysLow + (daysMedium * 1.14);
  
      // * high to low | 1.32
      daysLow = daysLow + (daysHigh * 1.32);

      // * comum to low | 0.94
      daysLow = daysLow + (daysComum * 0.94);
    } else {
      // * medium to low | 1.17
      daysLow = daysLow + (daysMedium * 1.17);

      // * high to low | 1.4
      daysLow = daysLow + (daysHigh * 1.4);

      // * comum to low | 0.93
      daysLow = daysLow + (daysComum * 0.93);
    }
    
    response.years = Math.floor(daysLow / 365);
    response.months = Math.floor((daysLow % 365) / 30);
    response.days = Math.floor((daysLow % 365) % 30);
  } else if (
    daysMedium > daysLow && 
    daysMedium > daysHigh
  ) {
    response.mainDisabledLevel = "medium";
    response.mainDisabledLevelLabel = "Moderada";

    if (gender === "Homem") {
      // * low to medium | 0.88
      daysMedium = daysMedium + (daysLow * 0.88);
  
      // * high to medium | 1.16
      daysMedium = daysMedium + (daysHigh * 1.16);

      // * comum to medium | 0.83
      daysMedium = daysMedium + (daysComum * 0.83);
    } else {
      // * low to medium | 0.86
      daysMedium = daysMedium + (daysLow * 0.86);

      // * high to medium | 1.2
      daysMedium = daysMedium + (daysHigh * 1.2);

      // * comum to medium | 0.8
      daysMedium = daysMedium + (daysComum * 0.8);
    }

    response.years = Math.floor(daysMedium / 365);
    response.months = Math.floor((daysMedium % 365) / 30);
    response.days = Math.floor((daysMedium % 365) % 30);
  } else if (
    daysHigh > daysLow && 
    daysHigh > daysMedium
  ) { 
    response.mainDisabledLevel = "high";
    response.mainDisabledLevelLabel = "Grave";

    if (gender === "Homem") {
      // * low to high | 0.76
      daysHigh = daysHigh + (daysLow * 0.76);
  
      // * medium to high | 0.86
      daysHigh = daysHigh + (daysMedium * 0.86);

      // * comum to high | 0.71
      daysHigh = daysHigh + (daysComum * 0.71);
    } else {
      // * low to high | 0.71
      daysHigh = daysHigh + (daysLow * 0.71);

      // * medium to high | 0.83
      daysHigh = daysHigh + (daysMedium * 0.83);

      // * comum to high | 0.67
      daysHigh = daysHigh + (daysComum * 0.67);
    }

    response.years = Math.floor(daysHigh / 365);
    response.months = Math.floor((daysHigh % 365) / 30);
    response.days = Math.floor((daysHigh % 365) % 30);
  }

  return response;
}

const calculateTimeByDays = (totalDays) => {
  const daysInYear = 365;
  const daysInMonth = 30;

  // Calcular anos, meses e dias
  const years = Math.floor(totalDays / daysInYear);
  const remainingDaysAfterYears = totalDays % daysInYear;

  const months = Math.floor(remainingDaysAfterYears / daysInMonth);
  const days = Math.floor(remainingDaysAfterYears % daysInMonth);

  return { years, months, days };
}

const getTimeOld = (workRecords, limitDate = null, field = null, gender, regimeDate) => {
  let dates = [];

  let disablementLevel = null;

  if (field && field.includes("isDisabled")) {
    disablementLevel = field.split("-")[1];
    field = "isDisabled";
  }

  workRecords.forEach((workRecord) => {
    const { ingressDate, egressDate, addition, deduction1, deduction2, deduction3, isSpecialTime, disabledLevel } = workRecord;      

    if (!field || (field && workRecord[field] && (!disablementLevel || disablementLevel === disabledLevel))) {
      if (isSpecialTime && !field && moment(ingressDate).isBefore(moment(regimeDate))) {
        const multiple = (gender === "Homem") ? 1.4 : 1.2;

        if (limitDate) {
          if (moment(ingressDate).isBefore(limitDate)) {
            let egress = null;

            let isLimitDate = false;

            if (moment(egressDate).isBefore(limitDate)) {
              egress = moment(egressDate);
            } else {
              egress = moment(limitDate);
              isLimitDate = true;
            }

            let isBefore2019 = false;

            if (egress.isSameOrBefore(regimeDate)) {
              egress = moment(isLimitDate ? limitDate : egressDate);
              isBefore2019 = true;
            } else {
              egress = moment(regimeDate);
            }

            let ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
    
            // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
              egress.subtract(deduction2, 'days');
            // }
      
            // if (moment(limitDate).isAfter(moment(regimeDate))) {
              egress.subtract(deduction3, 'days');
            // }

            let days = egress.diff(ingress, 'days');

            days *= multiple;

            if (!isBefore2019) {
              egress = moment(isLimitDate ? limitDate : egressDate);
              ingress = moment(regimeDate).add(1, 'day');

              let days2 = egress.diff(ingress, 'days');

              days += days2;
            }

            dates.push({ days });
          }
        } else {
          let egress = null;
          let isBefore2019 = false;

          if (moment(egressDate).isSameOrBefore(regimeDate)) {
            egress = moment(egressDate);
            isBefore2019 = true;
          } else {
            egress = moment(regimeDate);
          }

          let ingress = moment(ingressDate);
  
          egress.add((addition * 2), 'days');
          egress.subtract(deduction1, 'days');
          egress.subtract(deduction2, 'days');
          egress.subtract(deduction3, 'days');

          let days = egress.diff(ingress, 'days');

          days *= multiple;

          if (!isBefore2019) {
            egress = moment(egressDate);
            ingress = moment(regimeDate).add(1, 'day');

            let days2 = egress.diff(ingress, 'days');

            days += days2;
          }
    
          dates.push({ days });
        }
      } else {
        if (limitDate) {

          if (moment(ingressDate).isBefore(limitDate)) {
            let egress = null;

            if (moment(egressDate).isBefore(limitDate)) {
              egress = moment(egressDate)
            } else {
              egress = moment(limitDate);
            }

            let ingress = moment(ingressDate);

            egress.add((addition * 2), 'days');
            egress.subtract(deduction1, 'days');
    
            // if (moment(limitDate).isAfter(moment('1998-12-16'))) {
              egress.subtract(deduction2, 'days');
            // }
      
            // if (moment(limitDate).isAfter(moment(regimeDate))) {
              egress.subtract(deduction3, 'days');
            // }

            const days = egress.diff(ingress, 'days');

            dates.push({ days });
          }
        } else {
          let egress = moment(egressDate);
          let ingress = moment(ingressDate);
  
          egress.add((addition * 2), 'days');
          egress.subtract(deduction1, 'days');
          egress.subtract(deduction2, 'days');
          egress.subtract(deduction3, 'days');

          const days = egress.diff(ingress, 'days');
    
          dates.push({ days });
        }
      }
    }
  });

  let days = 0;

  for (const date of dates) {
    days += date.days;
  }

  const result = calculateTimeByDays(days);

  let years = result.years;
  let months = result.months;
  days = result.days;

  const hasTime = (years+months+days) > 0;

  return { years, months, days, hasTime };
}

const dates = {
    'União': '2019-11-13',
    'PR': '2019-12-03',
    'SP': '2020-03-07',
    'ES': '2020-07-01',
    'RS': '2019-12-22',
    'MT': '2020-08-20',
    'PB': '2021-07-02',
    'Curitiba': '2021-12-31'
}

// Converte uma data de conclusão em `moment` SOMENTE quando ela existe e é
// válida; caso contrário devolve null. Sem isso, `moment(null)` produz um
// objeto INVÁLIDO que é truthy: ele escapa pelos `||` dos chamadores e vira
// `age = NaN` lá na frente, deixando o laço do redutor sem branch de saída
// (travamento da aba "Regras Não Aplicáveis" — MG rules 343/344, 31/07/2026).
const toValidMoment = (value) => {
  if (value === null || value === undefined) return null;
  const parsed = moment(value);
  return parsed.isValid() ? parsed : null;
};

// Teto de segurança do laço que reduz idade x tempo excedente. O laço decrementa
// 1 ano por volta a partir da idade exigida, então qualquer caso legítimo sai em
// poucas dezenas de iterações; passar disso significa dado inconsistente e a
// resposta correta é "sem data calculável", nunca congelar a tela.
const MAX_ITERATIONS_REDUCTOR = 200;

const getRegimeDate = (regime) => {
    let date = dates[regime];
  
    if (regime === 'Sem Reforma') date = moment().add(1, 'day').format('YYYY-MM-DD');
    
    if (!date) return null;

    return moment(date);
}

const getIPAddress = async () => {
  return await fetch('https://api.ipify.org?format=json')
  .then(x => x.json())
  .then(({ ip }) => {
    return ip;
  });
}

const calculateToll = (necessaryContributionYears, { contributionYears, contributionMonths, contributionDays }, multiple) => {
  let days = necessaryContributionYears * 365;

  let contrDays = contributionYears * 365;
  contrDays += contributionMonths * 30;
  contrDays += contributionDays;

  days -= contrDays;

  days = days * multiple;

  let years = Math.floor(days / 365);
  let remainingDays = days % 365;

  let months = Math.floor(remainingDays / 30);
  remainingDays = remainingDays % 30;

  days = remainingDays;

  years = necessaryContributionYears + Math.floor(years);
  months = Math.floor(months);
  days = Math.floor(days);

  return { years, months, days };
}

// Função para calcular percentuais específicos de pedágio baseado no regime
const specificTolls = (regimeName, percentage, necessaryYears, contributedY, contributedM, contributedD) => {
  // Implementação da regra específica para Soledade - RS
  const soledadeSpecificTollRule = (necessaryYears, contributedY, contributedM, contributedD) => {
    let y = necessaryYears - (contributedY || 0);
    let m = 0 - (contributedM || 0);
    let d = 0 - (contributedD || 0);

    while (d < 0) { d += 30; m -= 1; }
    while (m < 0) { m += 12; y -= 1; }

    if (y < 0) { y = 0; m = 0; d = 0; }

    const remaining = { years: y, months: m, days: d };

    const lte = (a, b) => {
      if (a.years !== b.years) return a.years < b.years;
      return a.days <= b.days;
    };

    if (lte(remaining, { years: 2, months: 0, days: 0 })) return 50;
    if (lte(remaining, { years: 5, months: 0, days: 0 })) return 60;
    if (lte(remaining, { years: 8, months: 0, days: 0 })) return 70;
    return 100;
  };

  // Implementação da regra específica para Porto Alegre - RS
  const portoAlegreSpecificTollRule = (necessaryYears, contributedY, contributedM, contributedD) => {

    let y = necessaryYears - (contributedY || 0);
    let m = 0 - (contributedM || 0);
    let d = 0 - (contributedD || 0);


    while (d < 0) { d += 30; m -= 1; }
    while (m < 0) { m += 12; y -= 1; }

    if (y < 0) { y = 0; m = 0; d = 0; }

    const remaining = { years: y, months: m, days: d };

    const lte = (a, b) => {
      if (a.years !== b.years) return a.years < b.years;
      if (a.months !== b.months) return a.months < b.months;
      return a.days <= b.days;
    };


    if (lte(remaining, { years: 5, months: 0, days: 0 })) return 50;
    if (lte(remaining, { years: 8, months: 0, days: 0 })) return 70;
    return 100;
  };

  const tollVerifiers = {
    'Soledade - RS': soledadeSpecificTollRule,
    'Porto Alegre - RS': portoAlegreSpecificTollRule,
  };

  const verifier = regimeName && tollVerifiers[regimeName.trim()];
  return typeof verifier === 'function'
    ? verifier(necessaryYears, contributedY, contributedM, contributedD)
    : percentage;
}

const getNecessaryPointsTable = (rule, year, month) => {
  const currentYear = year || moment().year();
  const currentMonth = month || moment().month();
  const gender = rule?.gender;
  const isTeaching = rule?.necessaryTeachingTime > 0;
  const regime = rule?.regimeType === 'RGPS' ? 'RGPS' : rule?.calculation?.regime;
  const isSpecial = rule?.necessarySpecialTime > 0;
  const pointsTableName = rule?.pointsTableName;

  let tableName = 'default';

  if (pointsTableName) {
    tableName = pointsTableName;
  } else {
    if (isTeaching) tableName = 'Magistério';
    if (isSpecial) tableName = 'Especial';
  }

  const pointsRegime = specificPoints[regime] ? specificPoints[regime] : specificPoints['default'];
  const pointsTable = pointsRegime[gender][tableName] || pointsRegime[gender]['default'];

  if (pointsTable.useMonths) {
    if (currentYear < pointsTable.initialYear) {
      return pointsTable.initialPoints;
    }

    if (currentYear > pointsTable.finalYear) {
      return pointsTable.finalPoints;
    }

    let pointsMonth = pointsTable[currentYear]['month'];

    if (!pointsMonth || (currentMonth + 1) >= pointsMonth) {
      return pointsTable[currentYear]['points'];
    }

    return pointsTable[currentYear - 1]['points'];
  }

  if (currentYear < pointsTable.initialYear) {
    return pointsTable.initialPoints;
  }

  if (currentYear > pointsTable.finalYear) {
    return pointsTable.finalPoints;
  }

  return pointsTable[currentYear];
}

const calculateReachedContributionDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {

    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();

    let necessaryContributionTime = rule.necessaryContribution || 0;

    let reachedDate = null;

    let tollDate = rule?.tollDate ? moment(rule.tollDate) : null;

    if (rule?.isTollAtRegime) {
      tollDate = moment(regimeDate);
    }

    if (necessaryContributionTime) {
      if (rule?.modality === "Pedágio 20%") {
        const workRecords = rule?.workHistory || [];

        necessaryContributionTime = rule.increasedNecessaryContribution || necessaryContributionTime;
        let necessaryContributionTimeMonths = rule.increasedNecessaryContributionMonths || 0;
        let necessaryContributionTimeDays = rule.increasedNecessaryContributionDays || 0;

        const {
          days: contributionTimeDaysIn2019,
          months: contributionTimeMonthsIn2019,
          years: contributionTimeYearsIn2019
        } = getTime(workRecords, moment(limitDate), null, rule.gender, regimeDate);

        let tollYears = 0;
        let tollMonths = 0;
        let tollDays = 0;

        if (contributionTimeYearsIn2019 < necessaryContributionTime) {
          tollYears = necessaryContributionTime - contributionTimeYearsIn2019;
          tollMonths = contributionTimeMonthsIn2019;
          tollDays = contributionTimeDaysIn2019;

          if (tollMonths > 0 || tollDays > 0) {
            tollYears -= 1;
          }

          if (tollMonths > 0) {
            tollMonths = 12 - tollMonths;
          }

          if (tollDays > 0) {
            tollMonths -= 1;
            tollDays = 30 - tollDays;
          }

          // Verificar se deve usar tabela específica de pedágio
          let tollPercentage = 0.2; // Padrão 20%
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 20,
              necessaryContributionTime,
              contributionTimeYearsIn2019,
              contributionTimeMonthsIn2019,
              contributionTimeDaysIn2019
            );
            tollPercentage = specificPercentage / 100;
          }

          tollYears *= tollPercentage;
          tollMonths *= tollPercentage;
          tollDays *= tollPercentage;

          if (tollDays >= 30) {
            const daysToMonths = Math.floor(tollDays / 30);

            tollDays -= (daysToMonths * 30);
            tollMonths += daysToMonths;
          }

          if (tollMonths >= 12) {
            const monthsToYears = Math.floor(tollMonths / 12);

            tollMonths -= (monthsToYears * 12);
            tollYears += monthsToYears;
          }

          let finalDate = moment(limitDate)
            .add(tollYears, 'years')
            .add(tollMonths, 'months')
            .add(tollDays, 'days')

          if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
            finalDate = moment(rule.ruleStartDate);
          }

          reachedDate = finalDate;
        } else {
          const extraTime = contributionTimeYearsIn2019 - necessaryContributionTime;
          const extraTimeMonths = contributionTimeMonthsIn2019 - necessaryContributionTimeMonths;
          const extraTimeDays = contributionTimeDaysIn2019 - necessaryContributionTimeDays;

          let finalDate = moment(limitDate)
            .subtract(extraTime || 0, 'years')
            .subtract(extraTimeMonths || 0, 'months')
            .subtract(extraTimeDays || 0, 'days')

          if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
            finalDate = moment(rule.ruleStartDate);
          }

          reachedDate = finalDate;
        }
      } else if (rule?.modality.includes("Pedágio")) {
        const workRecords = rule?.workHistory || [];
        const {
          days: contributionTimeDaysIn2019,
          months: contributionTimeMonthsIn2019,
          years: contributionTimeYearsIn2019
        } = getTime(workRecords, moment(limitDate), null, rule.gender, regimeDate);

        let tollYears = 0;
        let tollMonths = 0;
        let tollDays = 0;

        if (contributionTimeYearsIn2019 < necessaryContributionTime) {
          tollYears = necessaryContributionTime - contributionTimeYearsIn2019;
          tollMonths = contributionTimeMonthsIn2019;
          tollDays = contributionTimeDaysIn2019;

          if (tollMonths > 0 || tollDays > 0) {
            tollYears -= 1;
          }

          if (tollMonths > 0) {
            tollMonths = 12 - tollMonths;
          }

          if (tollDays > 0) {
            tollMonths -= 1;
            tollDays = 30 - tollDays;
          }

          // Verificar se deve usar tabela específica de pedágio
          let tollPercentage = 2; // Padrão 100% (multiplicação por 2)
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              necessaryContributionTime,
              contributionTimeYearsIn2019,
              contributionTimeMonthsIn2019,
              contributionTimeDaysIn2019
            );
            tollPercentage = specificPercentage / 100;
          }

          tollYears *= tollPercentage;
          tollMonths *= tollPercentage;
          tollDays *= tollPercentage;

          if (tollDays >= 30) {
            const daysToMonths = Math.floor(tollDays / 30);

            tollDays -= (daysToMonths * 30);
            tollMonths += daysToMonths;
          }

          if (tollMonths >= 12) {
            const monthsToYears = Math.floor(tollMonths / 12);

            tollMonths -= (monthsToYears * 12);
            tollYears += monthsToYears;
          }

          let finalDate = moment(limitDate)
            .add(tollYears, 'years')
            .add(tollMonths, 'months')
            .add(tollDays, 'days')

          if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
            finalDate = moment(rule.ruleStartDate);
          }

          reachedDate = finalDate;
        } else {
          const extraYears = contributionTimeYearsIn2019 - necessaryContributionTime;

          const { 
            days: contributionTimeDaysAtToll,
            months: contributionTimeMonthsAtToll,
            years: contributionTimeYearsAtToll
          } = getTime(workRecords, moment(tollDate || limitDate), null, rule.gender, regimeDate);
          
          let tollPercentage = rule?.tollPercentage || 100;
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              necessaryContributionTime,
              contributionTimeYearsAtToll,
              contributionTimeMonthsAtToll,
              contributionTimeDaysAtToll
            );
            tollPercentage = specificPercentage;
          }

          const { 
            years: tollYearsAtToll, 
            months: tollMonthsAtToll, 
            days: tollDaysAtToll 
          } = calculateToll(
            necessaryContributionTime, 
            {
              contributionYears: contributionTimeYearsAtToll,
              contributionMonths: contributionTimeMonthsAtToll,
              contributionDays: contributionTimeDaysAtToll
            }, 
            tollPercentage / 100
          );

          let finalDate = moment(limitDate)
            .subtract(extraYears || 0, 'years')
            .subtract(contributionTimeMonthsIn2019 || 0, 'months')
            .subtract(contributionTimeDaysIn2019 || 0, 'days')
            .add(tollYearsAtToll - necessaryContributionTime || 0, 'years')
            .add(tollMonthsAtToll || 0, 'months')
            .add(tollDaysAtToll || 0, 'days')

          if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
            finalDate = moment(rule.ruleStartDate);
          }

          reachedDate = finalDate;
        }
      } else if(rule.modality.includes("Deficiência")) {
        const workRecords = rule?.workHistory || [];
        let level = null;
        if (rule.modality.includes("Leve")) level = "low";
        if (rule.modality.includes("Moderada")) level = "medium";
        if (rule.modality.includes("Grave")) level = "high";
        let field = "isDisabled";
        if (level) {
          field = `${field}-${level}`;
        }

        let contributionTimeDays = 0;
        let contributionTimeMonths = 0;
        let contributionTimeYears = 0;

        const disabledLowTimeGeral = getTime(workRecords, moment(limitDate), 'isDisabled-low', rule?.gender, regimeDate);
        const disabledMediumTimeGeral = getTime(workRecords, moment(limitDate), 'isDisabled-medium', rule?.gender, regimeDate);
        const disabledHighTimeGeral = getTime(workRecords, moment(limitDate), 'isDisabled-high', rule?.gender, regimeDate);
        const comumContributionGeral = getTime(workRecords, moment(limitDate), 'comum', rule?.gender, regimeDate, true);
        const mainDisabledTimeGeral = getMainDisabledTimeWithConversion(rule?.gender, disabledLowTimeGeral, disabledMediumTimeGeral, disabledHighTimeGeral, comumContributionGeral);

        if (mainDisabledTimeGeral.mainDisabledLevel && mainDisabledTimeGeral.mainDisabledLevel == level) {
          contributionTimeDays = mainDisabledTimeGeral.days;
          contributionTimeMonths = mainDisabledTimeGeral.months;
          contributionTimeYears = mainDisabledTimeGeral.years;
        } else {
          const {
            days: contributionTimeDaysTime,
            months: contributionTimeMonthsTime,
            years: contributionTimeYearsTime
          } = getTime(workRecords, moment(limitDate), field, rule?.gender, regimeDate);

          contributionTimeDays = contributionTimeDaysTime;
          contributionTimeMonths = contributionTimeMonthsTime;
          contributionTimeYears = contributionTimeYearsTime;
        }

        const extraTime = contributionTimeYears - necessaryContributionTime;

        let finalDate = moment(limitDate)
          .subtract(extraTime || 0, 'years')
          .subtract(contributionTimeMonths || 0, 'months')
          .subtract(contributionTimeDays || 0, 'days')

        if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
          finalDate = moment(rule.ruleStartDate);
        }

        reachedDate = finalDate;
      } else {
        const workRecords = rule?.workHistory || [];

        const {
          days: contributionTimeDays,
          months: contributionTimeMonths,
          years: contributionTimeYears
        } = getTime(workRecords, moment(limitDate), null, rule?.gender, regimeDate);

        const extraTime = contributionTimeYears - necessaryContributionTime;

        let finalDate = moment(limitDate)
          .subtract(extraTime || 0, 'years')
          .subtract(contributionTimeMonths || 0, 'months')
          .subtract(contributionTimeDays || 0, 'days')

        if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
          finalDate = moment(rule.ruleStartDate);
        }

        reachedDate = finalDate;
      }
    }
  
    return reachedDate;
  }

  return null;
}

const calculateReachedTeachingDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();

    let tollDate = rule?.tollDate ? moment(rule.tollDate) : null;

    if (rule?.isTollAtRegime) {
      tollDate = moment(regimeDate);
    }

    let necessaryTeachingTime = rule.increasedNecessaryTeachingTime || rule.necessaryTeachingTime || 0;
    let necessaryTeachingTimeMonths = rule.increasedNecessaryTeachingTimeMonths || 0;
    let necessaryTeachingTimeDays = rule.increasedNecessaryTeachingTimeDays || 0;
    let reachedDate = null;

    if (necessaryTeachingTime) {
      if ((rule?.modality).toUpperCase().includes("PEDÁGIO")) {
        const workRecords = rule?.workHistory || [];
        const {
          days: teachingTimeDaysIn2019,
          months: teachingTimeMonthsIn2019,
          years: teachingTimeYearsIn2019
        } = getTime(workRecords, moment(limitDate), 'isTeaching', rule?.gender, regimeDate);

        let tollYears = 0;
        let tollMonths = 0;
        let tollDays = 0;

        if (teachingTimeYearsIn2019 < necessaryTeachingTime) {
          tollYears = necessaryTeachingTime - teachingTimeYearsIn2019;
          tollMonths = teachingTimeMonthsIn2019;
          tollDays = teachingTimeDaysIn2019;

          if (tollMonths > 0 || tollDays > 0) {
            tollYears -= 1;
          }

          if (tollMonths > 0) {
            tollMonths = 12 - tollMonths;
          }

          if (tollDays > 0) {
            tollMonths -= 1;
            tollDays = 30 - tollDays;
          }

          // Verificar se deve usar tabela específica de pedágio
          let tollPercentage = 2; // Padrão 100% (multiplicação por 2)
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              necessaryTeachingTime,
              teachingTimeYearsIn2019,
              teachingTimeMonthsIn2019,
              teachingTimeDaysIn2019
            );
            tollPercentage = specificPercentage / 100;
          }

          tollYears *= tollPercentage;
          tollMonths *= tollPercentage;
          tollDays *= tollPercentage;

          if (tollDays >= 30) {
            const daysToMonths = Math.floor(tollDays / 30);

            tollDays -= (daysToMonths * 30);
            tollMonths += daysToMonths;
          }

          if (tollMonths >= 12) {
            const monthsToYears = Math.floor(tollMonths / 12);

            tollMonths -= (monthsToYears * 12);
            tollYears += monthsToYears;
          }

          let finalDate = moment(limitDate)
            .add(tollYears, 'years')
            .add(tollMonths, 'months')
            .add(tollDays, 'days')

          if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
            finalDate = moment(rule.ruleStartDate);
          }

          reachedDate = finalDate;
        } else {
          const { 
            days: teachingTimeDaysAtToll,
            months: teachingTimeMonthsAtToll,
            years: teachingTimeYearsAtToll
          } = getTime(workRecords, moment(tollDate || limitDate), 'isTeaching', rule.gender, regimeDate);

          let tollPercentage = rule?.tollPercentage || 100;
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              teachingTimeYearsAtToll,
              teachingTimeYearsAtToll,
              teachingTimeMonthsAtToll,
              teachingTimeDaysAtToll
            );
            tollPercentage = specificPercentage;
          }

          const { 
            years: tollYearsAtToll, 
            months: tollMonthsAtToll, 
            days: tollDaysAtToll 
          } = calculateToll(
            rule.necessaryTeachingTime, 
            {
              contributionYears: teachingTimeYearsAtToll,
              contributionMonths: teachingTimeMonthsAtToll,
              contributionDays: teachingTimeDaysAtToll
            }, 
            tollPercentage / 100
          );

          let finalDate

          if(tollYearsAtToll >= necessaryTeachingTime) {

            finalDate = getTime(workRecords, moment(limitDate), 'isTeaching', rule.gender, regimeDate, false, {
              years: tollYearsAtToll,
              months: tollMonthsAtToll,
              days: tollDaysAtToll
            });
            
            reachedDate = toValidMoment(finalDate.completionDate);
          } else {
            finalDate = getTime(workRecords, moment(tollDate || limitDate), 'isTeaching', rule.gender, regimeDate, false, {
              years: necessaryTeachingTime,
              months: 0,
              days: 0
            });
            reachedDate = toValidMoment(finalDate.completionDate);
          }

        }
      } else {
        let finalDate = getTime(rule?.workHistory, moment(limitDate), 'isTeaching', rule.gender, regimeDate, false, {
              years: necessaryTeachingTime,
              months: 0,
              days: 0
            });
            finalDate = toValidMoment(finalDate.completionDate);

        if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
          finalDate = moment(rule.ruleStartDate);
        }

        reachedDate = finalDate;
      }
    }

    return reachedDate;
  }
  
  return null;
}

const calculateReachedAgeDate = (rule, reachedContributionDate, reachedTeachingDate) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();
    
    let necessaryAge = rule.necessaryAge || 0;
    let necessaryAgeMonths = 0;
    let necessaryAgeDays = 0;
    let reachedDate = null;

    if (necessaryAge) {
      if (rule?.useTollTable && (rule.decreasedNecessaryAge || rule.decreasedNecessaryAgeMonths || rule.decreasedNecessaryAgeDays)) {
        necessaryAge = rule.decreasedNecessaryAge || necessaryAge;
        necessaryAgeMonths = rule.decreasedNecessaryAgeMonths || necessaryAgeMonths;
        necessaryAgeDays = rule.decreasedNecessaryAgeDays || necessaryAgeDays;
      }

      if (rule?.modality.includes("Com Redutor") || rule?.hasReductor) {
        let reachedContribution = toValidMoment(reachedContributionDate) || toValidMoment(reachedTeachingDate) || null;

        const start = moment(rule?.customer?.birthDate);
        let end = moment(reachedContribution);
        let age = end.diff(start, 'years');

        // Sem data de partida válida (requisito nunca alcançado) ou sem data de
        // nascimento, não há o que iterar: a idade seria NaN e o laço abaixo
        // nunca sairia. Devolve "sem data calculável" (mesmo retorno já usado
        // quando a regra não permite o cálculo).
        if (!reachedContribution || !start.isValid() || !Number.isFinite(age)) {
          return null;
        }

        let iterations = 0;

        do {
          if (++iterations > MAX_ITERATIONS_REDUCTOR) {
            return null;
          }

          if (age >= necessaryAge) {
            let finalDate = moment(reachedContribution);

            const finalYear = moment(reachedContribution).year();
            const birthdayBefore = moment(rule?.customer?.birthDate).year(finalYear);

            if (birthdayBefore.isBefore(reachedContribution)) {
              finalDate = birthdayBefore;
            }

            if (birthdayBefore.isAfter(reachedContribution)) {
              finalDate = birthdayBefore.subtract(1, 'year');
            }

            reachedDate = finalDate;

            break;
          }

          if (age < necessaryAge) {
            reachedContribution.add(1, 'year');
            necessaryAge -= 1;
            age += 1;
            rule.descreasedAge = necessaryAge;
          }
        } while (true);
      } else {
        let years = 0;
        let months = 0;
        let days = 0;

        const start = moment(rule?.customer?.birthDate);

        let end = moment(limitDate);

        years = end.diff(start, 'years');
        end = end.subtract(years, 'years');
        months = end.diff(start, 'months');
        end = end.subtract(months, 'months');
        days = end.diff(start, 'days');

        const extraTime = years - necessaryAge;

        const date = moment(limitDate);

        let finalDate = date
          .subtract(extraTime || 0, 'years')
          .subtract(months, 'months')
          .subtract(days, 'days')
          .add(necessaryAgeMonths, 'months')
          .add(necessaryAgeDays, 'days')

        if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
          finalDate = moment(rule.ruleStartDate);
        }

        reachedDate = moment(finalDate);
      }
    }

    return reachedDate;
  }

  return null;
}

const calculateReachedPositionDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();
    
    let necessaryPositionTime = rule.necessaryPositionTime || 0;
    let reachedDate = null;

    if (necessaryPositionTime) {
      const {
        years: positionTimeYears,
        months: positionTimeMonths,
        days: positionTimeDays
      } = getTime(rule?.workHistory, limitDate, 'isCurrentPosition', rule?.gender, regimeDate);

      const extraTime = positionTimeYears - necessaryPositionTime;

      let finalDate = moment(limitDate).subtract(extraTime || 0, 'years')
        .subtract(positionTimeMonths || 0, 'months')
        .subtract(positionTimeDays || 0, 'days')

      if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
        finalDate = moment(rule.ruleStartDate);
      }

      reachedDate = finalDate;
    }

    return reachedDate;
  }

  return null
}

const calculateReachedPublicServiceDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();
    
    let necessaryPublicServiceTime = rule.necessaryPublicServiceTime || 0;
    let reachedDate = null;

    if (necessaryPublicServiceTime) {
      const {
        years: publicServiceTimeYears,
        months: publicServiceTimeMonths,
        days: publicServiceTimeDays
      } = getTime(rule?.workHistory, limitDate, 'isPublicService', rule?.gender, regimeDate);

      const extraTime = publicServiceTimeYears - necessaryPublicServiceTime;

      let finalDate = moment(limitDate).subtract(extraTime || 0, 'years')
        .subtract(publicServiceTimeMonths || 0, 'months')
        .subtract(publicServiceTimeDays || 0, 'days')

      if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
        finalDate = moment(rule.ruleStartDate);
      }

      reachedDate = finalDate;
    }

    return reachedDate;
  }

  return null;
}

const calculateReachedPoliceDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();
    
    let necessaryPoliceTime = rule.necessaryPoliceTime || 0;
    let reachedDate = null;

    if (necessaryPoliceTime) {
      const {
        years: policeTimeYears,
        months: policeTimeMonths,
        days: policeTimeDays
      } = getTime(rule?.workHistory, limitDate, 'isPoliceTime', rule?.gender, regimeDate);

      const extraTime = policeTimeYears - necessaryPoliceTime;

      let finalDate = moment(limitDate).subtract(extraTime || 0, 'years')
        .subtract(policeTimeMonths || 0, 'months')
        .subtract(policeTimeDays || 0, 'days')

      if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
        finalDate = moment(rule.ruleStartDate);
      }

      reachedDate = finalDate;
    }

    return reachedDate;
  }

  return null;
}

const calculateReachedCarreerDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();

    let necessaryCarreerTime = rule.necessaryCarreerTime || 0;
    let reachedDate = null;

    if (necessaryCarreerTime) {
      const {
        years: carreerTimeYears,
        months: carreerTimeMonths,
        days: carreerTimeDays
      } = getTime(rule?.workHistory, limitDate, 'isCurrentCareer', rule?.gender, regimeDate);

      const extraTime = carreerTimeYears - necessaryCarreerTime;

      let finalDate = moment(limitDate).subtract(extraTime || 0, 'years')
        .subtract(carreerTimeMonths || 0, 'months')
        .subtract(carreerTimeDays || 0, 'days')

      if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
        finalDate = moment(rule.ruleStartDate);
      }

      reachedDate = finalDate;
    }

    return reachedDate;
  }

  return null;
}

const calculateReachedSpecialTimeDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();
    
    let field = "isSpecialTime";
    if (rule.necessarySpecialLevel) {
      field += `-${rule.necessarySpecialLevel}`;
    }

    let necessarySpecialTime = rule.necessarySpecialTime || 0;
    let reachedDate = null;

    if (necessarySpecialTime) {
      const workRecords = rule?.workHistory || [];

      let specialTimeYears = 0;
      let specialTimeMonths = 0;
      let specialTimeDays = 0;
      
      const {
        days: specialTimeDaysTime,
        months: specialTimeMonthsTime,
        years: specialTimeYearsTime
      } = getTime(workRecords, rule?.ruleLimitDate, field, rule?.gender, regimeDate);

      const specialTime15Geral = getTime(workRecords, null, 'isSpecialTime-15 anos', rule?.gender, regimeDate);
      const specialTime20Geral = getTime(workRecords, null, 'isSpecialTime-20 anos', rule?.gender, regimeDate);
      const specialTime25Geral = getTime(workRecords, null, 'isSpecialTime-25 anos', rule?.gender, regimeDate);
      const mainSpecialTime = getMainSpecialTimeWithConversion(specialTime15Geral, specialTime20Geral, specialTime25Geral);

      if (mainSpecialTime.mainSpecialLevel && mainSpecialTime.mainSpecialLevel == rule.necessarySpecialLevel) {
        specialTimeYears = mainSpecialTime.years;
        specialTimeMonths = mainSpecialTime.months;
        specialTimeDays = mainSpecialTime.days;
      } else {
        specialTimeYears = specialTimeYearsTime;
        specialTimeMonths = specialTimeMonthsTime;
        specialTimeDays = specialTimeDaysTime;
      }

      const extraTime = specialTimeYears - necessarySpecialTime;

      const date = rule?.ruleLimitDate ? moment(rule?.ruleLimitDate) : moment();

      let finalDate = date.subtract(extraTime || 0, 'years')
        .subtract(specialTimeMonths || 0, 'months')
        .subtract(specialTimeDays || 0, 'days')

      if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(finalDate)) {
        finalDate = moment(rule.ruleStartDate);
      }

      reachedDate = finalDate;
    }

    return reachedDate;
  }

  return null;
}

const calculateReachedContributionDateIgnoringStartDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;
    const limitDate = rule.ruleLimitDate ? moment(rule.ruleLimitDate) : moment();

    let necessaryContributionTime = rule.necessaryContribution || 0;

    let reachedDate = null;

    let tollDate = rule?.tollDate ? moment(rule.tollDate) : null;

    if (rule?.isTollAtRegime) {
      tollDate = moment(regimeDate);
    }

    if (necessaryContributionTime) {
      if ((rule?.modality).toUpperCase().includes("PEDÁGIO")) {
        const workRecords = rule?.workHistory || [];
        const {
          days: contributionTimeDaysIn2019,
          months: contributionTimeMonthsIn2019,
          years: contributionTimeYearsIn2019
        } = getTime(workRecords, moment(limitDate), null, rule.gender, regimeDate);

        let tollYears = 0;
        let tollMonths = 0;
        let tollDays = 0;

        if (contributionTimeYearsIn2019 < necessaryContributionTime) {
          tollYears = necessaryContributionTime - contributionTimeYearsIn2019;
          tollMonths = contributionTimeMonthsIn2019;
          tollDays = contributionTimeDaysIn2019;

          if (tollMonths > 0 || tollDays > 0) {
            tollYears -= 1;
          }

          if (tollMonths > 0) {
            tollMonths = 12 - tollMonths;
          }

          if (tollDays > 0) {
            tollMonths -= 1;
            tollDays = 30 - tollDays;
          }

          // Verificar se deve usar tabela específica de pedágio
          let tollPercentage = rule?.tollPercentage || 100;
          
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              necessaryContributionTime,
              contributionTimeYearsIn2019,
              contributionTimeMonthsIn2019,
              contributionTimeDaysIn2019
            );
            tollPercentage = specificPercentage / 100;
          }

          tollYears *= tollPercentage;
          tollMonths *= tollPercentage;
          tollDays *= tollPercentage;

          if (tollDays >= 30) {
            const daysToMonths = Math.floor(tollDays / 30);

            tollDays -= (daysToMonths * 30);
            tollMonths += daysToMonths;
          }

          if (tollMonths >= 12) {
            const monthsToYears = Math.floor(tollMonths / 12);

            tollMonths -= (monthsToYears * 12);
            tollYears += monthsToYears;
          }

          let finalDate = moment(limitDate)
            .add(tollYears, 'years')
            .add(tollMonths, 'months')
            .add(tollDays, 'days')

          reachedDate = finalDate;
        } else {
          const extraYears = contributionTimeYearsIn2019 - necessaryContributionTime;

          const { 
            days: contributionTimeDaysAtToll,
            months: contributionTimeMonthsAtToll,
            years: contributionTimeYearsAtToll
          } = getTime(workRecords, moment(tollDate || limitDate), null, rule.gender, regimeDate);
          
          let tollPercentage = rule?.tollPercentage || 100;
          if (rule?.useTollTable) {
            const specificPercentage = specificTolls(
              rule?.regime?.name || rule?.calculation?.regime,
              rule?.tollPercentage || 100,
              necessaryContributionTime,
              contributionTimeYearsAtToll,
              contributionTimeMonthsAtToll,
              contributionTimeDaysAtToll
            );
            tollPercentage = specificPercentage;
          }

          const { 
            years: tollYearsAtToll, 
            months: tollMonthsAtToll, 
            days: tollDaysAtToll 
          } = calculateToll(
            necessaryContributionTime, 
            {
              contributionYears: contributionTimeYearsAtToll,
              contributionMonths: contributionTimeMonthsAtToll,
              contributionDays: contributionTimeDaysAtToll
            }, 
            tollPercentage / 100
          );

          let finalDate

          if(tollYearsAtToll >= necessaryContributionTime) {

            finalDate = getTime(workRecords, moment(limitDate), null, rule.gender, regimeDate, false, {
              years: tollYearsAtToll,
              months: tollMonthsAtToll,
              days: tollDaysAtToll
            });
            reachedDate = toValidMoment(finalDate.completionDate);
          } else {
            finalDate = getTime(workRecords, moment(tollDate || limitDate), null, rule.gender, regimeDate, false, {
              years: necessaryContributionTime,
              months: 0,
              days: 0
            });
            reachedDate = toValidMoment(finalDate.completionDate);
          }

        }
      } else {
        const workRecords = rule?.workHistory || [];

        const isDisabledRule = !!rule.necessaryDisabledTime;

        if (isDisabledRule) {
          // Tempo de deficiência em limitDate (gatilho por necessaryDisabledTime; nível por necessaryDisabledLevel)
          const contributionField = rule.necessaryDisabledLevel
            ? `isDisabled-${rule.necessaryDisabledLevel}`
            : 'isDisabled';

          const {
            days: contributionTimeDays,
            months: contributionTimeMonths,
            years: contributionTimeYears
          } = getTime(workRecords, moment(limitDate), contributionField, rule.gender, regimeDate);

          const extraTime = contributionTimeYears - necessaryContributionTime;

          reachedDate = moment(limitDate)
            .subtract(extraTime || 0, 'years')
            .subtract(contributionTimeMonths || 0, 'months')
            .subtract(contributionTimeDays || 0, 'days');

          // CONTENCAO (nao e correcao do motor): numa regra aplicavel o requisito foi
          // cumprido ate a limitDate; data posterior e invalida por definicao e induz
          // o INSS a erro. Melhor nao exibir do que exibir data falsa.
          if (reachedDate && moment(reachedDate).isAfter(moment(limitDate))) reachedDate = null;
        } else {
          const {
            days: contributionTimeDays,
            months: contributionTimeMonths,
            years: contributionTimeYears
          } = getTime(workRecords, moment(limitDate), null, rule.gender, regimeDate);

          const extraTime = contributionTimeYears - necessaryContributionTime;

          reachedDate = moment(limitDate)
            .subtract(extraTime || 0, 'years')
            .subtract(contributionTimeMonths || 0, 'months')
            .subtract(contributionTimeDays || 0, 'days');
        }
      }
    }
  
    return reachedDate;
  }

  return null;
}

const calculateReachedDates = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if (((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') || rule?.exclusion?.source === 'applicable') {
    let dates = [];

    const reachedContributionDateIgnoringStartDate = calculateReachedContributionDateIgnoringStartDate(rule);
    const reachedTeachingDate = calculateReachedTeachingDate(rule);
    const reachedContributionDate = calculateReachedContributionDate(rule);
    const reachedAgeDate = calculateReachedAgeDate(rule, reachedContributionDate, reachedTeachingDate);
    const reachedPositionDate = calculateReachedPositionDate(rule);
    const reachedPublicServiceDate = calculateReachedPublicServiceDate(rule);
    const reachedPoliceDate = calculateReachedPoliceDate(rule);
    const reachedCarreerDate = calculateReachedCarreerDate(rule);
    const reachedSpecialTimeDate = calculateReachedSpecialTimeDate(rule);

    if (reachedContributionDateIgnoringStartDate) {
      dates.push(reachedContributionDateIgnoringStartDate);
    }

    if (reachedTeachingDate) {
      dates.push(reachedTeachingDate);
    }

    if (reachedAgeDate) {
      dates.push(reachedAgeDate);
    }

    if (reachedPositionDate) {
      dates.push(reachedPositionDate);
    }

    if (reachedPublicServiceDate) {
      dates.push(reachedPublicServiceDate);
    }

    if (reachedPoliceDate) {
      dates.push(reachedPoliceDate);
    }

    if (reachedCarreerDate) {
      dates.push(reachedCarreerDate);
    }

    if (reachedSpecialTimeDate) {
      dates.push(reachedSpecialTimeDate);
    }

    dates = dates.filter(d => d);

    if (rule.necessaryPoints && dates.length > 0) {
      const reachedPointsDate = calculateReachedPointsDate(rule, dates);
      if (reachedPointsDate) {
        dates.push(reachedPointsDate);
      }
    }

    return dates;
  }

  return [];
}

const calculateReachedPointsDate = (rule, reachedDates) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    const regimeDate = rule?.regimeDate;

    let dates = reachedDates;

    if (dates.length === 0) return false;

    let lastDate = moment.max(dates);

    let necessaryPoints = rule.necessaryPoints || 0;
    let reachedDate = null;

    if (necessaryPoints) {
      const isTeaching = rule.necessaryTeachingTime > 0;
      const isFixedPoints = rule?.fixedPoints;
      const workRecords = rule?.workHistory || [];
      const gender = rule?.gender;
      const ignoreSpecial = rule.modality && rule.modality.toUpperCase().includes('ESPECIAL');

      let currentContributionYears = 0;
      let currentContributionMonths = 0;
      let currentContributionDays = 0;

      if (isTeaching) {
        const {
          days: teachingTimeDays,
          months: teachingTimeMonths,
          years: teachingTimeYears
        } = getTime(workRecords, moment(lastDate), null, gender, regimeDate);

        currentContributionYears = teachingTimeYears;
        currentContributionMonths = teachingTimeMonths;
        currentContributionDays = teachingTimeDays;
      } else {
        let {
          days: contributionTimeDays,
          months: contributionTimeMonths,
          years: contributionTimeYears
        } = getTime(workRecords, moment(lastDate), null, gender, regimeDate);

        if (rule.modality.toUpperCase().includes("ESPECIAL")){
          ({
            days: contributionTimeDays,
            months: contributionTimeMonths,
            years: contributionTimeYears
          } = getTime(workRecords, moment(lastDate), null, gender, regimeDate, true));
        }

        currentContributionYears = contributionTimeYears;
        currentContributionMonths = contributionTimeMonths;
        currentContributionDays = contributionTimeDays;
      }

      currentContributionDays += currentContributionMonths * 30;
      currentContributionDays += currentContributionYears * 365;

      const ageInDays = moment(lastDate).diff(moment(rule.customer?.birthDate), 'days');

      const pointsInDays = currentContributionDays + ageInDays;

      let now = moment(lastDate);
      let pastDate = moment(lastDate);
      let newYear = now.year();
      let newMonth = now.month();

      let currentNecessaryPoints = isFixedPoints ? necessaryPoints : getNecessaryPointsTable(rule, newYear, newMonth);
      let currentNecessaryPointsInDays = currentNecessaryPoints * 365;

      if (currentNecessaryPointsInDays > pointsInDays) {
        let iter = 0;
        do {
          iter++;
          const currentYear = newYear;
          const currentMonth = newMonth;

          currentNecessaryPoints = isFixedPoints ? necessaryPoints : getNecessaryPointsTable(rule, currentYear, currentMonth);
          currentNecessaryPointsInDays = currentNecessaryPoints * 365;

          const missingDays = Math.floor((currentNecessaryPointsInDays - pointsInDays) / 2);

          now.add(missingDays, 'days');

          newYear = now.year();

          if (newYear !== currentYear) {
            now = moment(lastDate);
            continue;
          }

          pastDate = now;
          break;
        } while (true);

        reachedDate = pastDate;
      }
    }

    return reachedDate;
  }

  return null;
}

const calculateRetiredDate = (rule) => {
  const isFuture = rule?.isFuture;
  const isNotApplicable = rule?.isNotApplicable;
  
  if ((!isFuture && !isNotApplicable) || rule?.exclusion?.source === 'applicable') {
    let dates = calculateReachedDates(rule);

    if (dates.length === 0) return false;

    let lastDate = moment.max(dates);

    const reachedPointsDate = calculateReachedPointsDate(rule, dates);

    if (reachedPointsDate && reachedPointsDate.isAfter(lastDate)) {
      lastDate = moment(reachedPointsDate);
    }

    if (rule?.ruleStartDate && moment(rule.ruleStartDate).isAfter(lastDate)) {
      lastDate = moment(rule.ruleStartDate);
    }

    return lastDate.format('DD/MM/YYYY');
  }
  return false
}

export {
    getTime,
    getRegimeDate,
    getIPAddress,
    getMainSpecialTimeWithConversion,
    getMainDisabledTimeWithConversion,
    calculateToll,
    specificTolls,
    getNecessaryPointsTable,
    calculateReachedContributionDate,
    calculateReachedTeachingDate,
    calculateReachedAgeDate,
    calculateReachedPositionDate,
    calculateReachedPublicServiceDate,
    calculateReachedPoliceDate,
    calculateReachedCarreerDate,
    calculateReachedSpecialTimeDate,
    calculateReachedContributionDateIgnoringStartDate,
    calculateReachedDates,
    calculateReachedPointsDate,
    calculateRetiredDate,
};
